/**
 * @const ProxyVideo We pass this to the scene in order to get the srcObject
 * We then pass the srcObject to our video component in PersonaVideo.tsx
 */
const ProxyVideo = document.createElement("video") as HTMLVideoElement;
// These two values need to be added to proxy video in order to work on mobile IOS
ProxyVideo.playsInline = true;
ProxyVideo.autoplay = true;
ProxyVideo.setAttribute("data-sm-video", "");

export default ProxyVideo;
